<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'IP Interface Overview Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="addNewRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <div
                  @click="editSelectRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="delSelectRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
        <span style="float: right">
        <div class="pageButton">
          <button type="button" class="btn btn-primary" @click="clkApply()">
            {{ "Apply" }}
          </button>
          <span style="margin-left: 10px">
            <button
              type="button"
              class="btn btn-default"
              style="min-width: 77px"
              @click="clkCancel()"
            >
              {{ "Cancel" }}
            </button>
          </span>
        </div>
        </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    @change="selectall()"
                    v-model="selAll"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th
                  v-for="(value, key) in vlanIfTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in tVlanIfTable"
                :key="row.index"
                :class="{
                  info: row.rowStatus === 'new' || row.rowStatus === 'edit',
                  delete: row.rowStatus === 'del',
                }"
                @dblclick="editDoubleClickRow(row)"
                @click.stop="
                  row.selected =
                    row.rowStatus === '' ? !row.selected : row.selected
                "
                style="
                  -moz-user-select: none; /*火狐*/
                  -webkit-user-select: none; /*webkit浏览器*/
                  -ms-user-select: none; /*IE10*/
                  -khtml-user-select: none; /*早期浏览器*/
                  user-select: none;
                "
              >
                <td width="40px">
                  <div v-if="row.rowStatus === ''">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + row.index"
                    />
                    <label></label>
                  </div>
                  <div v-else class="revocate" @click.stop="undoRow(row)">
                    <i class="fa fa-undo"></i>
                  </div>
                </td>
                <td
                  v-for="(value, key) in printableRow(row)"
                  :key="key"
                  :title="value"
                >
                  <!-- ifName 编辑 -->
                  <div
                    v-if="
                      key === 'ifName' &&
                      (row.rowStatus === 'new')
                    "
                  >
                    <span style="position: relative; display: block">
                      <select
                        v-model="row.newIfType"
                        class="form-control"
                      >
                      <option value="0">VLAN-IF</option>
                      <option value="1">superVLAN-IF</option>
                      </select>
                      <i
                        class="form-control-feedback glyphicon"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small class="help-block" style="display: none"
                        >The valid name is required</small
                      >
                    </span>
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_vlanid_check(row) }"
                    >
                      <input
                        type="text"
                        v-model="row.newVlanId"
                        class="form-control table-edit"
                        maxlength="4"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_vlanid_check(row) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_vlanid_check(row) ? 'block' : 'none',
                        }"
                        >{{ input_vlanid_check(row) }}</small
                      >
                    </span>
                  </div>
                  <!-- vlan-interface vlanId 编辑 -->
                  <div v-else-if="key === 'vlanId' && row.rowStatus === 'new' && row.newIfType == 0">
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': false }"
                    >
                      <input
                        type="text"
                        v-model="row.newVlanId"
                        class="form-control table-edit"
                        maxlength="4"
                        disabled
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': false }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: 'none',
                        }"
                        >{{ input_vlanid_check(row) }}</small
                      >
                    </span>
                  </div>
                  <!-- supervlan-interface sub vlanId 编辑 -->
                  <div v-else-if="key === 'vlanId' && ((row.rowStatus === 'new' && row.newIfType == 1) || (row.rowStatus === 'edit' && row.ifType == 1))">
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_subvlan_check(row) }"
                    >
                      <input
                        type="text"
                        v-model="row.newVlanStr"
                        class="form-control table-edit"
                        size="8"
                        maxlength="256"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_subvlan_check(row) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_subvlan_check(row) ? 'block' : 'none',
                        }"
                        >{{ input_subvlan_check(row) }}</small
                      >
                    </span>
                  </div>
                  <!-- ifShutdown 编辑 -->
                  <div v-else-if="key === 'ifShutdown' && (row.rowStatus === 'new' || row.rowStatus === 'edit')">
                    <input
                      type="checkbox"
                      v-model="row.newIfShutdown"
                      class="form-control table-edit"
                      :id="'idIfShutdown' + row.index"
                    />
                    <label :for="'idIfShutdown' + row.index">{{ row.newIfShutdown }}</label>
                  </div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>

import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "vlanIfTable",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.ipconfigif,
      vlanIfTable: "",
      tVlanIfTable: "",
      selAll: false,
      iBox: {},
      newRowCount: 0,
      maxNewRowCount: 5,
      newRow: {
        index: 0,
        ifType: 0,
        ifName: "",
        vlanId: "",
        primaryIp: "",
        ifShutdown: false,
        status: "",
        rowStatus: "new",
        newIfType: 0,
        newVlanId: 1,
        newVlanStr: "",
        newIfShutdown: false
      }
    }
  },
  created() {
    this.loadvlanif()
  },
  methods: {
    loadvlanif() {
      get("vlanIfTable")
        .then((res) => {
          this.vlanIfTable = res.data
          this.dataInit()
        })
        .catch((err) => {
          this.vlanIfTable = en.vlanIfTable
          this.dataInit()
        })
    },

    /* 页面数据初始化 */
    dataInit() {
        this.tVlanIfTable = JSON.parse(JSON.stringify(this.vlanIfTable.data))
        this.tVlanIfTable.forEach((element) => {
        this.$set(element, "rowStatus", "")
        this.$set(element, "selected", false)
        this.$set(element, "newIfType", element["ifType"])
        this.$set(element, "newVlanId", 0)
        this.$set(element, "newVlanStr", element["vlanId"] !== "None" ? element["vlanId"] : "")
        this.$set(element, "ifShutdown", (element["ifShutdown"] === "true" || element["ifShutdown"] === true) ? true : false)
        this.$set(element, "newIfShutdown", element["ifShutdown"])
        })
        this.selAll = false
        this.newRowCount = 0
    },

    /* 页面提交函数 */
    clkApply() {
      var postData = {}
      var newRows = []
      var editRows = []
      var delRows = []
      var vt = this.tVlanIfTable
      for (var v = 0; v < vt.length; v++) {
        if (
          vt[v]["rowStatus"] !== "new" &&
          vt[v]["rowStatus"] !== "edit" &&
          vt[v]["rowStatus"] !== "del"
        )
          continue
        if (vt[v]["rowStatus"] === "new" || vt[v]["rowStatus"] === "edit") {
          // 单元参数再次检查
          if ((vt[v]["rowStatus"] === "new" && this.input_vlanid_check(vt[v])) ||
              ((vt[v]["rowStatus"] === "new" || vt[v]["rowStatus"] === "edit") && this.input_subvlan_check(vt[v]))) {
            this.showAlertBox("warn", "warnning", "Fix the mistake first!")
            return
          }
          // 行内逻辑检查
        }
        // 新行添加冲突检查，编辑行前后对比检查，而后准备数据
        if (vt[v]["rowStatus"] === "new") {
          // 添加新行操作，进行冲突检查
          var skip = false
          for (var d = 0; d < vt.length; d++) {
            if ((d < v && vt[d]["rowStatus"] === "new") || v === d) continue
            // 冲突检查
            if (
              vt[v]["newIfType"] ==
              (vt[d]["rowStatus"] === "new" ? vt[d]["newIfType"] : vt[d]["ifType"]) &&
              ((vt[v]["newIfType"] == "0" ? "VLAN-IF" : "superVLAN-IF") + vt[v]["newVlanId"]) ===
              (vt[d]["rowStatus"] === "new" ? ((vt[d]["newIfType"] == "0" ? "VLAN-IF" : "superVLAN-IF") + vt[d]["newVlanId"]) : vt[d]["ifName"])
            ) {
              var msg = (vt[v]["newIfType"] == "0" ? "VLAN-IF" : "superVLAN-IF") + vt[v]["newVlanId"]
              if (vt[d]["rowStatus"] === "new") {
                msg += " repeat add!"
              } else if (vt[d]["rowStatus"] === "del") {
                msg += " add and delete conflict!"
              } else {
                msg += " already exist!"
              }
              this.showAlertBox("warn", "Warnning", msg)
              return
            }
          }
          var row = { vlanId: parseInt(vt[v]["newVlanId"]) }
          //if (vt[v]["newIfType"] !== this.newRow["newIfType"])
            row["ifType"] = vt[v]["newIfType"]
          if (vt[v]["newIfType"] == "1" && vt[v]["newVlanStr"] !== this.newRow["newVlanStr"] && vt[v]["newVlanStr"] !== "None")
            row["subVlan"] = vt[v]["newVlanStr"]
          if (vt[v]["newIfShutdown"] !== this.newRow["newIfShutdown"])
            row["ifShutdown"] = vt[v]["newIfShutdown"]
          newRows.push(row)
        } else if (vt[v]["rowStatus"] === "edit") {// 编辑操作，进行编辑前后变更检查
          if (
            vt[v]["vlanId"] === vt[v]["newVlanStr"] &&
            vt[v]["ifShutdown"] === vt[v]["newIfShutdown"]
          )
            continue
          var row = { ifName: vt[v]["ifName"] }
          if (vt[v]["ifType"] == "1" && vt[v]["vlanId"] !== vt[v]["newVlanStr"] && vt[v]["newVlanStr"] !== "None")
            row["subVlan"] = vt[v]["newVlanStr"]
          if (vt[v]["newIfShutdown"] !== vt[v]["ifShutdown"])
            row["ifShutdown"] = vt[v]["newIfShutdown"]
          editRows.push(row)
        } else if (vt[v]["rowStatus"] === "del") {// 删除操作
          delRows.push({ ifName: vt[v]["ifName"] })
        }
      }
      if (!newRows.length && !editRows.length && !delRows.length) {
        this.showAlertBox("info", "Info", "Nothing to do!")
        return
      }
      if (newRows.length) postData["add"] = newRows
      if (editRows.length) postData["edit"] = editRows
      if (delRows.length) postData["del"] = delRows
      post("vlanIfTable", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              "Message",
              res.data.msg !== undefined ? res.data.msg : "Unknown error!"
            )
          this.loadvlanif()
        })
        .catch((err) => {
          this.showAlertBox("critical", "Error", err)
        })
    },

    /* 页面恢复函数 */
    clkCancel() {
      this.dataInit()
    },

    /* 参数输入检查 */
    input_vlanid_check(row) {
    var vid;
      if (row["newIfType"] == 1 && row["rowStatus"] === "edit")
        vid = (row["newVlanStr"] != "" && row["newVlanStr"] != "None") ? parseInt(row["newVlanStr"]) : 1
      else
        vid = parseInt(row["newVlanId"])
      if (isNaN(vid)) vid = 0

      if (vid < 1 || vid > 4094)
        return "VLAN ID must be between 1-4094."
      return null
    },

    /* 参数输入检查 */
    input_subvlan_check(row) {
    var vid;
        vid = (row["newVlanStr"] !== "" && row["newVlanStr"] !== "None") ? parseInt(row["newVlanStr"]) : 1
      if (isNaN(vid)) vid = 0

      if (vid < 1 || vid > 4094)
        return "Sub VLAN ID must be between 1-4094."
      return null
    },

    /* 表头添加新行 */
    addNewRow() {
      var vt = this.tVlanIfTable
      /*if (vt.length >= 4094)
        this.showAlertBox("info", "Warnning", "Table is full.")
      else*/ if (this.newRowCount >= this.maxNewRowCount)
        this.showAlertBox("info", "Warnning", "Too many new row.")
      else {
        vt.unshift(JSON.parse(JSON.stringify(this.newRow)))
        this.newRowCount++
        // 获取新行索引
        var vt1 = JSON.parse(JSON.stringify(vt))
        vt1.sort((a, b) => {
          return a.index - b.index
        })
        for (var idx = 1; idx <= 4094; idx++) {
          if (vt.length <= idx || idx != vt1[idx].index) {
            vt[0].index = idx
            break
          }
        }
      }
    },

    /* 双击编辑行 */
    editDoubleClickRow(row) {
      if (row["rowStatus"] === "") {
        row["rowStatus"] = "edit"
        row["selected"] = false
        row["newVlanStr"] = row["vlanId"] !== "None" ? row["vlanId"] : ""
        row["ifShutdown"] = (row["ifShutdown"] === "true" || row["ifShutdown"] === true) ? true : false
        row["newIfShutdown"] = row["ifShutdown"]
      }
    },

    /* 编辑选择的行 */
    editSelectRow() {
      var vt = this.tVlanIfTable
      vt.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "edit"
          element["selected"] = false
          element["newVlanStr"] = element["vlanId"] !== "None" ? element["vlanId"] : ""
          element["ifShutdown"] = (element["ifShutdown"] === "true" || element["ifShutdown"] === true) ? true : false
          element["newIfShutdown"] = element["ifShutdown"]
        }
      })
    },

    /* 删除选择的行 */
    delSelectRow() {
      var vt = this.tVlanIfTable
      vt.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "del"
          element["selected"] = false
        }
      })
    },

    /* 撤销行操作 */
    undoRow(row) {
      var vt = this.tVlanIfTable
      if (row["rowStatus"] === "new") {
        var fi = vt.findIndex((r) => r.index === row.index)
        if (fi !== -1) {
          vt.splice(fi, 1)
          this.newRowCount--
        }
      } else if (row["rowStatus"] === "edit" || row["rowStatus"] === "del") {
        row["rowStatus"] = ""
        row["selected"] = false
      }
    },

    /* 行有效打印 */
    printableRow(row) {
      var prow = {}
      for (var c in row) {
        if (
          c === "rowStatus" ||
          c === "selected" ||
          c === "newVlanId" ||
          c === "newIfType" ||
          c === "ifType" ||
          c === "newVlanStr" ||
          c === "newIfShutdown"
        )
          continue
        prow[c] = row[c]
      }
      return prow
    },

    /* 选择全部行 */
    selectall() {
      this.tVlanIfTable.forEach((element) => {
        if (element["rowStatus"] === "") element["selected"] = this.selAll
      })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
/*
      var portMap = [
        { typte: "p", port: "1-16" },
        { typte: "e", port: "1-4" },
        { typte: "e", port: "1-2" },
      ]
      txt = "e1/1-e1/2, d/e, e1/4, e2/1-e2/2, e5/6-e5/2"

      var p = []
      txt
        .replace(/\s+/g, "")
        .split(",")
        .map((v, i) => {
          var range = v.split("-")
          var t1, t2, s1, s2, p1, p2
          t1 = range[0].split("/")
          if (t1.length < 2 || t1[0].length < 2) {
            t1 = t1[0][0]
            s1 = parseInt(t1[0].slice(1))
            if (isNaN(s1)) alert(s1)
          }
          // 不是范围
          if (range.length < 2) {
            return
          }

          t2 = range[0].split("/")
          if (t2.length < 2 || t2[0].length < 2) alert("geshibudui")
        })
*/
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
